export default {
  app: {
    name: 'Snippet',
    flags: {},
    viewport: {
      width: null,
      height: null,
      type: null,
    },
    createProgramFormScope: {},
  },
  session: {},
  staff: {},
  schools: {},
  programs: {},
  programTemplates: {},
  static: {},
};



// WEBPACK FOOTER //
// ./src/store/initialState.js